import { DrawerWideSize } from '../model/DrawerWideSize';

const calcSizeLgUpWidth = (size: DrawerWideSize): string => {
  if (size === 'medium') {
    return '48rem';
  } else {
    return '70rem';
  }
};

export const TemporaryDrawerMapper = {
  calcSizeLgUpWidth,
};
